import styled from "styled-components";

import { device } from "utils/sizes";
import { colourScheme } from "utils/styling/colours";

export const Main = styled.main`
    gap: 2rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    align-self: center;
    width: 100%;
    ${device.lg} {
        width: 80%;
    }
    ${device.xl} {
        width: 75%;
    }
`;

export const ImageGalleryWrapper = styled.div`
    width: 100vw;
`;

export const AboutSection = styled.div`
    margin-top: 5rem;
    padding: 1.25rem;
`;

export const AboutTitle = styled.h2`
    color: ${colourScheme.success};
`;

export const AboutText = styled.p`
    color: ${colourScheme.fullWhite};
`;
